export default __webpack_public_path__ + "static/impromed-1e08626ba661013f6385e774bca7230a.png";